export default __webpack_public_path__ + "static/media/weather app.baa5d7b3.webp";